


























































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Instance, InstanceGroupInstance } from "@/services/instances/types";
import { getInstances } from "@/services/instances/instanceService";
import { selectInstancesFields } from "@/components/instances/fields/selectInstancesFields";
import { RoleEnum } from "@/store/authentication/types";
import i18n from "@/i18n";

const namespace: string = "authentication";

@Component
export default class SelectInstancesModal extends Vue {
    @Getter("authorize", { namespace }) authorize: any;
    instances = [] as Instance[];
    fields = selectInstancesFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;
    selectedInstances = [] as Instance[];
    multiPicker = false;
    roles = RoleEnum;
    // filter options
    searchQuery = "";
    // lifecycle hooks

    // computed
    get filteredData() {
        return this.instances && this.instances
            .filter(x => this.searchQuery.length === 0 ||
            (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    get title(): string {
        return i18n.t("instanceGroups.selectInstances").toString();
    }

    // methods
    async fetchData(preselectedInstances: any) {
        this.isBusy = true;
        const allInstances = await getInstances();
        this.instances = allInstances.filter(x => (x.restricted ? this.authorize(this.roles.RestrictedAccessRole) : true) && !preselectedInstances.includes(x.id));
        this.isBusy = false;
    }

    rowSelected(items: Instance[]) {
        this.selectedInstances = items;
    }

    open(multiPicker = false, preselectedInstances: any) {
        this.multiPicker = multiPicker;
        this.fetchData(preselectedInstances);
        this.$bvModal.show("modal-selectInstance");
    }

    save() {
        this.$bvModal.hide("modal-selectInstance");
        if (!this.selectedInstances || this.selectedInstances.length === 0) {
            return;
        }

        this.$emit("select", this.selectedInstances.map(instance => {
            return {
                instanceId: instance.id,
                name: instance.name
            } as InstanceGroupInstance;
        }));
    }

    resetState() {
        this.searchQuery = "";
        this.selectedInstances = [] as Instance[];
    }
}
